import { LogOut, Radio } from "lucide-react";
import { useAuth } from "@/lib/auth";
import AgentConsole from "@/pages/AgentConsole";


export default function AgentPortal() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-[color:var(--bg-base)]">
      <header className="h-14 border-b border-[color:var(--border-default)] bg-[color:var(--bg-surface)] flex items-center px-4 gap-3">
        <Radio size={17} className="text-[color:var(--accent-green)]" />
        <div>
          <div className="text-[10px] uppercase tracking-widest text-[color:var(--text-muted)]">Voxyra IPBX</div>
          <div className="text-sm font-semibold">Painel do agente</div>
        </div>
        <div className="flex-1" />
        <div className="text-right">
          <div className="text-xs font-medium">{user?.name}</div>
          <div className="text-[10px] text-[color:var(--text-muted)]">{user?.email}</div>
        </div>
        <button className="sbc-btn" onClick={logout} title="Sair"><LogOut size={14} /></button>
      </header>
      <main className="p-4 lg:p-6"><AgentConsole /></main>
    </div>
  );
}
